import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

export const IconPair = () => (
    <div className='uikit-icons'>
        <Headline headlineType='h3' anchor='pairIcons'>
            Pair icons
        </Headline>
        <Playground example={iconPairIconsExample} />
    </div>
);

const iconPairIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Default</Title>
            <div className='display-flex flex-wrap gap-10'>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-climate-control spinning' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-stack' />
                        <span className='uikit-icon icon-plus' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-trailer' />
                        <span className='uikit-icon icon-ok text-color-success' />
                    </span>
                </div>
            </div>
        </div>
        <div>
            <Title>With background</Title>
            <div className='display-flex flex-wrap gap-10'>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-climate-control spinning bg-darkest text-color-white' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-bus' />
                        <span className='uikit-icon icon-heart bg-danger text-color-white' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-trailer' />
                        <span className='uikit-icon icon-ok bg-success text-color-white' />
                    </span>
                </div>
            </div>
        </div>
        <div>
            <Title>Display engine types</Title>
            <div className='display-flex flex-wrap gap-10'>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-liquid' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-bus' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-van' />
                        <span className='uikit-icon icon-fuel-hydrogen' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-trailer' />
                        <span className='uikit-icon icon-fuel-gas' />
                    </span>
                </div>
            </div>
            <div className='display-flex flex-wrap gap-10 margin-top-20'>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-liquid bg-darkest text-color-white' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-bus' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-van' />
                        <span className='uikit-icon icon-fuel-hydrogen bg-darkest text-color-white' />
                    </span>
                </div>
                <div>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-trailer' />
                        <span className='uikit-icon icon-fuel-gas bg-darkest text-color-white' />
                    </span>
                </div>
            </div>
        </div>
        <div>
            <Title>Sized</Title>
            <div className='display-flex flex-wrap gap-10'>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h2'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h3'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-20'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-18'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-16'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-14'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric' />
                    </span>
                </div>
            </div>
            <div className='display-flex flex-wrap gap-10 margin-top-20'>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h1'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h2'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-h3'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-20'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-18'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-16'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
                <div className='display-flex align-items-start'>
                    <span className='uikit-icon-pair text-size-14'>
                        <span className='uikit-icon icon-truck' />
                        <span className='uikit-icon icon-fuel-electric bg-darkest text-color-white' />
                    </span>
                </div>
            </div>
        </div>
    </div>
);
